import { render, staticRenderFns } from "./SlideComponent.vue?vue&type=template&id=de481b5e"
import script from "./SlideComponent.vue?vue&type=script&lang=js"
export * from "./SlideComponent.vue?vue&type=script&lang=js"
import style0 from "./SlideComponent.vue?vue&type=style&index=0&id=de481b5e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports